// Gambiko : ajout au panier depuis les cartes produit de l'accueil.
// Même circuit que product-form.js : /cart/add.js, puis CartUpdatedEvent (tiroir et compteur du thème) et ouverture du panier.
// Avec data-added (cartes produit des articles) : pas d'ouverture du panier, libellé « Ajouté » pendant 2 s puis retour.
import { ThemeEvents, CartUpdatedEvent } from '@theme/events';

if (!window.gkAjoutPanier) {
  window.gkAjoutPanier = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-gk-add]');
    if (!button || button.getAttribute('aria-busy') === 'true' || button.dataset.state === 'added') return;

    const label = button.textContent;
    let ok = false;
    button.setAttribute('aria-busy', 'true');
    button.textContent = button.dataset.busy;

    const drawer = document.querySelector('cart-drawer');
    const sections = ['auto-gifts'];
    if (drawer?.dataset.sectionId) sections.push(drawer.dataset.sectionId);

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(button.dataset.gkAdd), quantity: 1 }], sections: sections.join(',') }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || response.status);

      const cart = await fetch(Theme.routes.cart_url + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      document.dispatchEvent(new CartUpdatedEvent({}, { itemCount: cart.item_count, source: 'gk-accueil', sections: data.sections }));
      if (!button.dataset.added) document.dispatchEvent(new Event(ThemeEvents.cartOpen));
      ok = true;
    } catch (error) {
      document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'error', message: button.dataset.error } }));
      console.error('Gambiko ajout au panier :', error);
    } finally {
      button.removeAttribute('aria-busy');
      button.textContent = label;
      if (ok && button.dataset.added) {
        button.dataset.state = 'added';
        button.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="5,12 10,17 19,7"/></svg>';
        button.append(button.dataset.added);
        setTimeout(() => { delete button.dataset.state; button.textContent = label; }, 2000);
      }
    }
  });
}
